import { render, staticRenderFns } from "./UserViewActionCard.vue?vue&type=template&id=3f572ecc&"
import script from "./UserViewActionCard.vue?vue&type=script&lang=js&"
export * from "./UserViewActionCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports